<hr class="upperline" />

<div class="my-account-form-container terra-error-style" [formGroup]="formGroup" [class.loading-container-overlay]="isLoading">
  <div class="form-grid">
    @if(isDisabled) {
      <p>You can't change this because you are using extrenal login provider</p>
    }
    <!-- Current password -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtPassword" class="text-input-label">Current password</label>
      <mat-form-field appearance="outline" class="half-width">
        <input type="password" matInput id="txtPassword" formControlName="password" required maxlength="256" class="lo_sensitive" />
        @if(formGroup.get('password').invalid) {
          <mat-error>
            @if(formGroup.get('password').hasError('required')) {
              Password is required
            } @else {
              The password is invalid
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  
    <!-- New email -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtEmail" class="text-input-label">New email</label>
      <mat-form-field appearance="outline" class="half-width">
        <input type="email" matInput id="txtEmail" formControlName="email" required maxlength="256" class="lo_sensitive" autocorrect="off" spellcheck="false" autocomplete="off" readonly (focus)="this.removeReadonly($event)" />
        @if(formGroup.get('email').invalid) {
          <mat-error>
            @if(formGroup.get('email').hasError('required')) {
              Email is required
            } @else if(formGroup.get('email').hasError('email')) {
              Please enter a valid email address
            } @else if(formGroup.get('email').hasError('emailexist')) {
              The email already exists
            } @else {
              An error has occurred.
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="pb-3">
      <ngx-recaptcha2 #recaptcha formControlName="recaptcha" class="recaptcha" [siteKey]="recaptchaPublicKey" />
      @if(formGroup.get('recaptcha').invalid && formGroup.get('recaptcha').touched) {
        <mat-error>Please enter recaptcha</mat-error>
      }
    </div>
    @if(isLoading) {
      <terra-loader class="full-width" centerToParent="true" />
    }

    <div class="form-actions full-width">
      <button mat-flat-button color="accent" [disabled]="isDisabled" class="page-cta half-width tall-button" (click)="changeEmail()">
        Save
      </button>
    </div>
  </div>
</div>
